module.exports = __webpack_public_path__ + "images/paknbak1dd8f74bf011645b8c96e2dcb63804c6.png";